import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import BillReportsHeader from '../BillReportsHeader';
import BillReportsContent from '../BillReportsContent';
import { fetchBillsData } from '../../../store/slices/billReportsSlice';

const BillReports = () => {
    const dispatch = useDispatch();

    // Auto-fetch last 30 days data on mount across every branch of the client;
    // the header lets ADMIN narrow it down to a single branch afterwards.
    useEffect(() => {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);

        dispatch(fetchBillsData({
            fromDate,
            toDate,
            branchId: 'All',
            status: ''
        }));
    }, [dispatch]);

    return (
        <>
            <BillReportsHeader />
            <BillReportsContent />
        </>
    );
};

export default BillReports;
